import { useParams } from 'react-router-dom';
import { CaseDetailsFilesContainer } from '../components/case-details-files.container';
import { SubPageLayout } from '../../../../sub-page-layout';
import { Helmet } from 'react-helmet';

export const CaseFilesIdentityVerificationCase: React.FC = () => {
  const params = useParams();
  return (
    <div style={{ marginTop: '64px' }}>
      <Helmet>
        <title>Case - Files</title>
      </Helmet>
      <SubPageLayout >
        <CaseDetailsFilesContainer caseId={params['caseId'] as string} />
      </SubPageLayout>
    </div>
  );
};
